import React from 'react';
import { Phone, Calendar } from 'lucide-react';
export function StickyMobileCTA() {
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 p-3 flex gap-3 z-50 lg:hidden shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)]" data-id="element-210">
      <a href="tel:5175457772" className="flex-1 bg-white border-2 border-brandBlue-600 text-brandBlue-600 font-bold py-3 px-4 rounded-xl flex items-center justify-center gap-2" data-id="element-211">
        <Phone className="w-5 h-5" data-id="element-212" />
        Call
      </a>
      <a href="#estimate-form" className="flex-1 bg-brandBlue-600 text-white font-bold py-3 px-4 rounded-xl flex items-center justify-center gap-2" data-id="element-213">
        <Calendar className="w-5 h-5" data-id="element-214" />
        Estimate
      </a>
    </div>;
}